module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-1-hero-ad5b5154151748dc356c3dd2b647483c.jpg";